import { SortingDirection } from '@components/core-ui/Table';
import { Spinner } from './components/Spinner';
import { TProps } from './types/TProps';

export const DisclosureSection = ({
  title,
  open,
  setOpenState,
  loading,
  children,
  className = '',
  titleClassName = '',
}: TProps) => {
  return (
    <div className={`${className} mb-6`}>
      <div className="relative">
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-t border-[var(--color-divider)]" />
        </div>
        <div className="relative flex justify-start">
          <span
            className={`bg-[var(--color-page)] pr-2 font-[600] text-xs text-foreground-muted cursor-pointer ${titleClassName}`}
            onClick={() => setOpenState(!open)}
          >
            {title} <SortingDirection reverse={open} />
          </span>
        </div>
      </div>
      <div className={open ? 'visible' : 'hidden'}>
        {loading && <Spinner />}
        {!loading && children}
      </div>
    </div>
  );
};
